/* 🤖 this file was generated by script */
export const wiconPlus = {
  name: 'plus',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v14m-7-7h14"/></svg>`,
};
